export default __webpack_public_path__ + "static/media/capture.bf63b067.svg";